// src/types/kanban.ts
// Tipos TypeScript para el modulo Kanban

// Enums
export enum TipoTableroKanban {
  TICKETS = 'TICKETS',
  ACTIVIDADES = 'ACTIVIDADES',
  SPRINT = 'SPRINT',
  PERSONALIZADO = 'PERSONALIZADO'
}

export enum AgrupacionKanban {
  ESTADO = 'ESTADO',
  PRIORIDAD = 'PRIORIDAD',
  ASIGNADO = 'ASIGNADO',
  CLIENTE = 'CLIENTE',
  TIPO = 'TIPO',
  CATEGORIA = 'CATEGORIA',
  MODULO_ERP = 'MODULO_ERP'
}

export enum OrdenKanban {
  MANUAL = 'MANUAL',
  PRIORIDAD = 'PRIORIDAD',
  FECHA_CREACION = 'FECHA_CREACION',
  FECHA_LIMITE = 'FECHA_LIMITE',
  ULTIMO_MOVIMIENTO = 'ULTIMO_MOVIMIENTO'
}

// Configuracion de columna
export interface ColumnaConfig {
  valor: string;
  nombre?: string;
  color?: string;
  icono?: string;
  limite_wip?: number;
  es_oculta?: boolean;
  es_colapsada?: boolean;
}

// CRUD Tablero
export interface TableroCreate {
  nombre: string;
  descripcion?: string;
  tipo: TipoTableroKanban;
  agrupacion?: AgrupacionKanban;
  filtros?: Record<string, any>;
  orden_tarjetas?: OrdenKanban;
  columnas_config?: ColumnaConfig[];
  campos_visibles?: string[];
  mostrar_archivados?: boolean;
  limite_por_columna?: number;
  color_por?: string;
  tamano_tarjeta?: string;
}

export interface TableroUpdate {
  nombre?: string;
  descripcion?: string;
  agrupacion?: AgrupacionKanban;
  filtros?: Record<string, any>;
  orden_tarjetas?: OrdenKanban;
  columnas_config?: ColumnaConfig[];
  campos_visibles?: string[];
  es_compartido?: boolean;
  mostrar_archivados?: boolean;
  limite_por_columna?: number;
  color_por?: string;
  tamano_tarjeta?: string;
}

export interface Tablero {
  id: string;
  usuario_id: string;
  nombre: string;
  descripcion?: string;
  tipo: TipoTableroKanban;
  agrupacion: AgrupacionKanban;
  filtros?: Record<string, any>;
  orden_tarjetas: OrdenKanban;
  columnas_config?: ColumnaConfig[];
  campos_visibles?: string[];
  mostrar_archivados: boolean;
  limite_por_columna?: number;
  color_por?: string;
  tamano_tarjeta: string;
  es_default: boolean;
  es_compartido: boolean;
  activo: boolean;
  created_at: string;
  updated_at?: string;
}

// Usuario en tarjeta
export interface UsuarioResumenKanban {
  id: string;
  nombre: string;
  email?: string;
  avatar?: string;
}

// Tarjeta Kanban
export interface TarjetaKanban {
  id: string;
  tipo: 'ticket' | 'actividad';
  orden: number;
  titulo: string;
  descripcion_corta?: string;
  prioridad?: string;
  estado: string;
  created_at: string;
  updated_at?: string;
  // Campos ticket
  numero?: string;
  cliente?: string;
  tipo_ticket?: string;
  // Campos actividad
  fecha_limite?: string;
  tipo_actividad?: string;
  proyecto?: string;
  // Visuales
  color?: string;
  etiquetas: string[];
  asignado?: UsuarioResumenKanban;
  comentarios_count: number;
  adjuntos_count: number;
}

// Columna con tarjetas
export interface ColumnaKanban {
  valor: string;
  nombre: string;
  color?: string;
  icono?: string;
  limite_wip?: number;
  es_colapsada: boolean;
  tarjetas: TarjetaKanban[];
  total: number;
  excede_limite: boolean;
}

// Tablero completo con datos
export interface TableroKanbanData {
  tablero: Tablero;
  columnas: ColumnaKanban[];
  total_tarjetas: number;
  agrupaciones_disponibles: string[];
}

// Movimiento
export interface MoverTarjetaRequest {
  entidad_tipo: 'ticket' | 'actividad';
  entidad_id: string;
  columna_destino: string;
  posicion: number;
}

export interface MoverMultiplesRequest {
  movimientos: MoverTarjetaRequest[];
}

export interface ReordenarColumnaRequest {
  columna: string;
  orden: string[];
  entidad_tipo?: 'ticket' | 'actividad';
}

export interface MoverTarjetaResponse {
  tarjeta: TarjetaKanban;
  columna_origen: string;
  columna_destino: string;
  cambio_estado: boolean;
}

// Estadisticas
export interface EstadisticasColumna {
  columna: string;
  total: number;
  porcentaje: number;
}

export interface EstadisticasTablero {
  total_tarjetas: number;
  por_columna: EstadisticasColumna[];
  tiempo_promedio_por_columna?: Record<string, number>;
}

// Agrupaciones
export interface AgrupacionInfo {
  valor: string;
  nombre: string;
  descripcion?: string;
}

export interface ValorAgrupacion {
  valor: string;
  nombre: string;
  color?: string;
  icono?: string;
  count: number;
}
